export default __webpack_public_path__ + "static/media/sentiment.169c4984.svg";